<template>
  <el-card shadow="never">
    <el-row :gutter="20">
      <el-col :span="8">
        <FormItem :label="$t('analysesData.symbolLotBulkEdit.symbol')">
          <AutocompleteSymbol v-model="aggregatedSymbol" />
        </FormItem>
      </el-col>
      <el-col :span="8">
        <FormItem :label="$t('operations.create.symbolType')">
          <el-input
            :value="getSymbolTypeLabel(aggregatedSymbolType)"
            disabled
            v-once
          />
        </FormItem>
      </el-col>
      <el-col :span="8">
        <FormItem :label="$t('analysesData.symbolLotBulkEdit.lot')">
          <el-input v-model="lot" />
        </FormItem>
      </el-col>
      <el-col :span="24">
        <el-collapse v-model="activeNames">
          <el-collapse-item
            :title="$t('analysesData.symbolLotBulkEdit.details')"
            name="1"
          >
            <template v-if="activeNames.includes('1')">
              <el-row
                :gutter="20"
                v-for="(
                  operationValue, key
                ) in operationValuesGrouped.operationValues"
                :key="key"
              >
                <el-col :span="8">
                  <FormItem
                    :label="$t('analysesData.symbolLotBulkEdit.analysisCode')"
                  >
                    <el-input
                      :value="operationValue.analysisCode"
                      disabled
                      v-once
                    />
                  </FormItem>
                </el-col>
                <el-col :span="8">
                  <FormItem
                    :label="$t('analysesData.symbolLotBulkEdit.analysis')"
                  >
                    <el-input
                      :value="operationValue.analysisDescription"
                      disabled
                      v-once
                    />
                  </FormItem>
                </el-col>
                <el-col :span="8">
                  <FormItem :label="$t('analysesData.symbolLotBulkEdit.lot')">
                    <el-input
                      v-model="operationValue.symbolLot"
                      @change="handleSymbolLot(key)"
                    />
                  </FormItem>
                </el-col>
              </el-row>
            </template>
          </el-collapse-item>
        </el-collapse>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
  import { SymbolTypes } from '@/config/constants';
  import FormItem from '@/components/FormItem.vue';
  import AutocompleteSymbol from '@/components/AutocompleteSymbol.vue';

  export default {
    name: 'SymbolLotBulkEdit',
    components: {
      FormItem,
      AutocompleteSymbol,
    },
    props: {
      value: { type: Object, required: true },
      cardKey: { type: String, required: true },
      isOpen: { type: Boolean, default: false },
    },
    data() {
      return {
        aggregatedSymbol: '',
        aggregatedSymbolType: '',
        lot: '',
      };
    },
    computed: {
      symbolTypes() {
        return Object.values(SymbolTypes).map((val) => ({
          value: val,
          label: this.$t(`enums.symbolTypes.${val}`),
        }));
      },
      operationValuesGrouped() {
        return this.value;
      },
      activeNames: {
        get() {
          return this.isOpen ? ['1'] : [];
        },
        set(val) {
          const isOpen = val.includes('1');
          this.$emit('toggle-collapse', this.cardKey, isOpen);
        },
      },
    },
    watch: {
      lot(newVal) {
        this.operationValuesGrouped.symbolLot = newVal;
        this.operationValuesGrouped.operationValues.forEach((item) => {
          // eslint-disable-next-line no-param-reassign
          item.symbolLot = newVal;
          item.operations.forEach((op) => {
            // eslint-disable-next-line no-param-reassign
            op.symbolLot = newVal;
          });
        });
      },
      aggregatedSymbol(newVal) {
        this.operationValuesGrouped.symbol = newVal;
        this.operationValuesGrouped.operationValues.forEach((item) => {
          // eslint-disable-next-line no-param-reassign
          item.symbol = newVal;
          item.operations.forEach((op) => {
            // eslint-disable-next-line no-param-reassign
            op.symbol = newVal;
          });
        });
      },
    },
    created() {
      this.aggregatedSymbol = this.operationValuesGrouped.symbol;
      this.aggregatedSymbolType = this.operationValuesGrouped.symbolType;
      this.lot = this.operationValuesGrouped.symbolLot;
    },
    mounted() {},
    methods: {
      getSymbolTypeLabel(symbolType) {
        if (!symbolType) return '';
        return this.$t(`enums.symbolTypes.${symbolType}`);
      },
      handleSymbolLot(key) {
        this.operationValuesGrouped.operationValues[key].operations.forEach(
          (op) => {
            // eslint-disable-next-line no-param-reassign
            op.symbolLot =
              this.operationValuesGrouped.operationValues[key].symbolLot;
          }
        );
      },
    },
  };
</script>

<style lang="scss">
  .el-card {
    background-color: transparent;
    border: transparent;
  }
</style>
